import { comMethods } from '@/components/menu/com.js';
export default {
  components: {},
  mixins: [comMethods]
};